import { CellProps } from 'react-table'
import { EmpresasActionsCell } from './EmpresaActionsCell'
import { ClienteList } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** LocalDateTime do backend → "dd/mm/aaaa hh:mm"; ausente vira o traço do StackedCell. */
const dataHora = (date?: string) => (date ? formatDateTime(date) : undefined)

export const empresaClienteColumns = (t: TFunction): ReadonlyArray<TableColumn<ClienteList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<ClienteList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.nome ?? ''}`}
      />
    ),
  },
  // Documento é a linha de apoio do nome; os dois seguem ordenáveis.
  sortableColumn<ClienteList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.empregadorAso') },
      { field: 'documento', label: t('cols.documento') },
    ],
    Cell: ({ row }: CellProps<ClienteList>) => (
      <StackedCell
        tabular
        primary={row.original.nome}
        secondary={
          row.original.documento
            ? [row.original.tipoDocumento, row.original.documento].filter(Boolean).join(' ')
            : undefined
        }
      />
    ),
  }),
  sortableColumn<ClienteList>({
    id: 'empresa.nomeFantasia',
    cellWidth: '260px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('empresa.label') }],
    Cell: ({ row }: CellProps<ClienteList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  // Última edição em destaque; criação como linha de apoio.
  {
    Header: () => (
      <PlainHeader>
        {t('cols.data.edicao')} / {t('cols.data.criacao')}
      </PlainHeader>
    ),
    id: 'dataAlteracao',
    cellWidth: '188px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<ClienteList>) => (
      <StackedCell
        tabular
        primary={dataHora(row.original.dataAlteracao)}
        secondary={dataHora(row.original.dataInclusao)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.status')}</PlainHeader>,
    id: 'ativo',
    cellWidth: '112px',
    Cell: ({ row }: CellProps<ClienteList>) => <StatusBadge active={row.original.ativo} />,
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<ClienteList>) => <EmpresasActionsCell cliente={row.original} />,
  },
]
